import React from "react";
import SinglePillarContent from "@/components/nds/windows/pillar/SinglePillarContent";

export default function Pillar4DailyContent({ win }) {
  return <SinglePillarContent pillarId="PILLAR_4_DAILY" focus={win?.payload?.focus} />;
}
